module.exports = __webpack_public_path__ + "assets/82d1732aace5f24d2f7da6868f94f009.png";